import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const SettingsList = lazy(() => import('../../container/pages/SettingsList'));
const SettingsAdd = lazy(() => import('../../container/pages/SettingsAdd'));
const SettingsEdit = lazy(() => import('../../container/pages/SettingsEdit'));

const SettingRoute = () => {
  return (
    <Routes>
      <Route path="list" element={<SettingsList />} />
      <Route path="add" element={<SettingsAdd />} />
      <Route path="edit/:settingId" element={<SettingsEdit />} />
    </Routes>
  );
};

export default SettingRoute;
